export default __webpack_public_path__ + "static/media/people-fill-gray5-24.04e81cac.svg";